<script setup>
import { useToast } from '../../composables/useToast'
const { state, dismiss } = useToast()
const classes = { success: 'border-success-200 bg-success-50 text-success-700', error: 'border-danger-200 bg-danger-50 text-danger-700', warning: 'border-warning-200 bg-warning-50 text-warning-700', info: 'border-info-200 bg-info-50 text-info-700' }
</script>
<template>
  <Teleport to="body">
    <div class="pointer-events-none fixed inset-x-3 top-3 z-[100] flex flex-col items-end gap-2 sm:inset-x-auto sm:right-5 sm:top-5 sm:w-[24rem]" aria-live="polite" aria-atomic="false">
      <TransitionGroup name="toast">
        <div v-for="item in state.items" :key="item.id" class="pointer-events-auto flex w-full items-start gap-3 rounded-app-control border p-4 shadow-xl" :class="classes[item.type] || classes.info" role="status">
          <div class="mt-0.5 h-2.5 w-2.5 shrink-0 rounded-full bg-current"></div>
          <p class="min-w-0 flex-1 text-sm font-bold leading-5">{{ item.message }}</p>
          <button type="button" class="shrink-0 rounded-lg p-1 opacity-70 hover:bg-white/50 hover:opacity-100" aria-label="Закрыть уведомление" @click="dismiss(item.id)">×</button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
